
  //获取URL参数值
  export function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
  }

  // 获取Cookie
  export function _getCookie(name) {
    var arrStr = document.cookie.split("; ");
    for (var i = 0; i < arrStr.length; i++) {
      var temp = arrStr[i].split("=");
      if (temp[0] == name) return unescape(temp[1]);
    }
  }


  //添加cookie
  export function _addCookie(name, value, expired, domain) {
    var tmp = "";
    if (domain) {
      tmp = name + "=" + escape(value) + "; Path=/;domain=" + domain + ";";
    } else {
      tmp = name + "=" + escape(value) + "; Path=/;";
    }
    if (expired > 0) {
      var date = new Date();
      date.setTime(date.getTime() + expired * 3600000); //*hours
      tmp = tmp + " expires=" + date.toGMTString();
    }
    document.cookie = tmp;
  }


  // 校验是否登录
  // isLoginFun(isLogin){
  //     let isLogin = window.localStorage.getItem("isLogin"); // 为true已登录
  //     return isLogin;

  // }


